import { exportExcel } from "@api/stores/customerReports/exportExcel/path";
import { exportPDF } from "@api/stores/customerReports/exportPDF/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/customer-reports/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const customerReports = {
  getAll: apiPathFunc(pathBase),
  exportPDF,
  exportExcel,
};
